export interface MailProps {
  body: string;
  subject: string;
  to: string;
}

export default ({ body, subject, to }: MailProps) =>
  `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
